let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hM2vG")).then(() => parcelRequire('khZod'));